// app-pages/ModelsDashboard.tsx
"use client";
import { Box, Button, Flex, Grid, Text, Skeleton, Icon, Link as ChakraLink } from "@chakra-ui/react";
import { useGetAllModels, useGetUserModels } from "queries";
import { Jumbotron, ModelCard } from "components";
import { FaPlus, FaMagic, FaUpload } from "react-icons/fa";
import Link from "next/link";

const ModelsDashboard = () => {
  const {
    data: privateModelsData,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading: isPrivateModelsLoading, 
  } = useGetUserModels(11, []);
  const { data: publicModelsData } = useGetAllModels(false, 50, [], true, "");
  const publicModels = publicModelsData?.pages
    .flatMap((page: any) => page.models)
    .sort((a, b) => (b.isFlux ? 1 : 0) - (a.isFlux ? 1 : 0))
    .slice(0, 4);

  const privateModels = privateModelsData?.pages.flatMap((page: any) => page.models);

  return (
    <Flex direction="column">
      <Jumbotron height="100" >
       
      </Jumbotron>

      <Flex direction="column" px={["25px", "30px", "40px", "60px", "60px", "15%"]} align="center">
      <Box
  borderWidth="1px"
  borderColor="zinc.800"
  borderRadius="xl"
  bg="rgba(24, 24, 27, 0.5)"
  sx={{ backdropFilter: "blur(8px)" }}
  boxShadow="sm"
  w="100%"
  mb="50px"
>
  <Box
    borderRadius="xl"
    borderWidth="2px"
    borderColor="pink.500"
    opacity="0.5"
    filter="blur(4px)"
    pointerEvents="none" 
  />
  
  <Box pt="3" px="6" pb="6" position="relative">
    <Text
      mb="2"
      fontSize={{ base: "2xl", md: "3xl" }}
      fontWeight="bold"
      textAlign="center"
      bgGradient="linear(to-r, pink.500, purple.500)"
      bgClip="text"
      fontFamily="orbitron, sans-serif"
    >
      Create Your AI Character
    </Text>
    
    <Grid gap="4" templateColumns={{ base: "1fr", sm: "repeat(2, 1fr)" }}>
    <Box
  p="4"
  bg="rgba(39, 39, 42, 0.5)"
  borderRadius="lg"
  transition="background-color 0.3s"
  _hover={{ bg: "rgba(39, 39, 42, 0.7)" }}

>
  <ChakraLink
    href="https://magikface.com/?fpr=deepmode"
    target="_blank"
    display="inline-flex"
    alignItems="center"
    justifyContent="center"
    borderRadius="md"
    fontSize={{ base: "xs", sm: "sm" }}
    fontWeight="medium"
    h="10"
    px="3"
    py="2"
    w="full"
    bgGradient="linear(to-r, pink.600, purple.600)"
    color="white"
    transition="all 0.3s ease-in-out"
    textDecoration="none"
    position="relative" 
    _hover={{ 
      bgGradient: "linear(to-r, pink.700, purple.700)",
      transform: "scale(1.05)"
    }}
    whiteSpace="nowrap"
    textOverflow="ellipsis"
    overflow="hidden"
  >
    <Icon as={FaMagic} mr="1" h="4" w="4" flexShrink={0} />
    <Flex align="center" flexWrap="nowrap">
      <Text as="span" whiteSpace="nowrap">
        Design with
      </Text>
      <Text
        ml="1"
        color="white"
        fontWeight="700"
        whiteSpace="nowrap"
        flexShrink={0}
      >
        MagikFace
      </Text>
    </Flex>
  </ChakraLink>
</Box>
      
<Box
  p="4"
  bg="rgba(39, 39, 42, 0.5)"
  borderRadius="lg"
  transition="background-color 0.3s"
  _hover={{ bg: "rgba(39, 39, 42, 0.7)" }}
>
  <ChakraLink
    href="/train"
    display="inline-flex"
    alignItems="center"
    justifyContent="center"
    borderRadius="md"
    fontSize={{ base: "xs", sm: "sm" }}
    fontWeight="medium"
    h="10"
    px="3"
    py="2"
    w="full"
    bgGradient="linear(to-r, pink.600, purple.600)"
    color="white"
    transition="all 0.3s ease-in-out"
    textDecoration="none"
    _hover={{ 
      bgGradient: "linear(to-r, pink.700, purple.700)",
      transform: "scale(1.05)"
    }}
    whiteSpace="nowrap"
    textOverflow="ellipsis"
    overflow="hidden"
  >
    <Icon as={FaUpload} mr="1" h="4" w="4" flexShrink={0} />
    <Text as="span" whiteSpace="nowrap">
      Train with your images
    </Text>
  </ChakraLink>
</Box>
    </Grid>
  </Box>
</Box>

        <Flex direction="column" align="start">
          <Flex direction="column" align="start">
            <Text fontSize={{ base: "22px", md: "32px" }} fontWeight={600}>
              Private Models
            </Text>
            <Text fontSize={{ base: "12px", md: "16px" }} color="#F9FAFB">
              Create your AI model and generate images
            </Text>
          </Flex>

          <Grid
            gap={{ base: "28px", md: "24px" }}
            mt="15px"
            templateColumns={{
              base: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
              lg: "repeat(4, 1fr)",
            }}
          >
        <ChakraLink 
      href="/train" 
      _hover={{ textDecoration: "none" }}
      w="fit-content"
    >
      <Box
        borderWidth="1px"
        borderColor="#27272A"  
        borderRadius="xl"
        bg="rgba(24, 24, 27, 0.5)"
        sx={{ backdropFilter: "blur(8px)" }}
        boxShadow="sm"
        overflow="hidden"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        p={6}
        transition="all 0.3s ease"
        _hover={{ 
          bg: "rgba(39, 39, 42, 0.5)", 
          transform: "scale(1.05)"
        }}  
        w={{ base: "142px", md: "180px", lg: "264px" }}
        h="100%"
      >
        <Icon 
          as={FaPlus} 
          h={{ base: 8, md: 10, lg: 12 }} 
          w={{ base: 8, md: 10, lg: 12 }} 
          color="pink.500" 
          mb={4} 
        />
        
        <Text
          fontSize={{ base: "sm", md: "md", lg: "xl" }}
          fontWeight="semibold"
          color="white"
          mb={2}
          textAlign="center"
        >
          Train a new model
        </Text>
        
        <Button
          w="full"
          h={{ base: 8, md: 9, lg: 10 }}
          px={{ base: 2, md: 3, lg: 4 }}
          py={{ base: 1, md: 2 }}
          borderRadius="md"
          fontSize={{ base: "xs", md: "sm" }}
          fontWeight="medium"
          bgGradient="linear(to-r, pink.500, purple.500)"
          color="white"
          _hover={{ 
            bgGradient: "linear(to-r, pink.600, purple.600)",
            transform: "scale(1.05)" 
          }}
          transition="all 0.3s ease-in-out" 
        >
          Get Started
        </Button>
      </Box>
    </ChakraLink>


            {isPrivateModelsLoading &&
              [...Array(4)].map((_, index) => (
                <Skeleton key={index} borderRadius="14px"       h={{ base: "142px", md: "180px", lg: "264px" }}
                w={{ base: "142px", md: "180px", lg: "264px" }}
                />
              ))}

            {privateModels?.map((model, index) => (
              <ModelCard
                key={index}
                navigateToMyModels={true}
                model={model}
                refetch={() => {
                  console.log("");
                }}
              />
            ))}
          </Grid>

          {hasNextPage && (
            <Button
              onClick={() => fetchNextPage()}
              isLoading={isFetchingNextPage}
              mt="4"
              mb="8"
              bg="button.500"
              color="white"
              _hover={{ opacity: "0.9" }}
            >
              Load More
            </Button>
          )}

          <Flex
            direction={{ base: "column", md: "row" }}
            mt="100px"
            align={{ base: "start", md: "center" }}
            justify="space-between"
            w="100%"
          >
            <Flex direction="column">
              <Text fontSize={{ base: "22px", md: "32px" }} fontWeight={600}>
                Public Models
              </Text>
              <Text fontSize={{ base: "12px", md: "16px" }} color="#F9FAFB">
                Browse and create images on our public AI models
              </Text>
            </Flex>
<Link href="/public-models" passHref>
  <ChakraLink
    display="inline-flex"
    alignItems="center"
    justifyContent="center"
    rounded="md"
    fontSize="sm"
    fontWeight="medium"
    transition="colors 0.2s ease-in-out"
    _focusVisible={{
      outline: "none",
      ringWidth: "2px",
      ringColor: "ring",
      ringOffset: "2px",
      ringOffsetColor: "background",
    }}
    _disabled={{
      opacity: "0.5",
      pointerEvents: "none",
    }}
    borderWidth="1px"
    borderColor="#27272A"
    color="text"
    _hover={{
      bg: "#27272A",
      textDecoration: "none",
    }}
    h="10"
    px="4"
    py="2"
    mt={{ base: "10px", md: 0 }}
  >
    View All Models
  </ChakraLink>
</Link>
          </Flex>

          <Grid
            gap={{ base: "28px", md: "24px" }}
            mt="15px"
            templateColumns={{
              base: "repeat(2,1fr)",
              sm: "repeat(3,1fr)",
              lg: "repeat(4,1fr)",
            }}
          >
            {publicModels?.map((model, index) => (
              <ModelCard key={index} navigateToMyModels={false} model={model} refetch={() => {}} />
            ))}
          </Grid>
        </Flex>
        <Box h="200px" />
      </Flex>
    </Flex>
  );
};

export default ModelsDashboard;
